import { ImResponse, resolve, storeHomeNVClient } from 'services/api';

export function getPlatformData(params: {
  storeId: string | number;
  startTime: string;
  endTime: string;
}) {
  return resolve(
    storeHomeNVClient.get<
      ImResponse<
        {
          countDt: string;
          data: string;
          dt: string;
        }[]
      >
    >('/api_gateway/dashboard/platform/perf', { params }),
  );
}

export function exportPlatformData(body: {
  platform?: General.PlatformUpperCase;
  departmentIds: number[];
  startTime: string;
  endTime: string;
  storeType?: Dashboard.ReceptionScore.StoreType;
  storeIds: string[];
}) {
  return storeHomeNVClient.post('/api_gateway/dashboard/platform/perf/export', body);
}

export interface GetStorePerfListParams {
  sortKey?: string;
  sortType?: 1 | 2;
  pageNum: number;
  pageSize: number;
  platform: General.PlatformUpperCase;
  departmentIds?: number[];
  storeType?: '本土' | '跨境';
  storeIds?: number[];
}

export function getStorePerfList(params: GetStorePerfListParams) {
  return resolve(
    storeHomeNVClient.post<
      ImResponse<{
        list: Dashboard.PlatformData.StorePerfData[];
        total: number;
        pageNum: number;
        pageSize: number;
      }>
    >('/api_gateway/dashboard/platform/perf/list', params),
  );
}

export function getCsatList(params: {
  pageNum: number;
  pageSize: number;
  platform: General.PlatformUpperCase;
  departmentIds?: number[];
  storeType?: '本土' | '跨境';
  storeIds?: number[];
  scoreList?: number[];
  buyerNick: string;
  startTimeStamp: string;
  endTimeStamp: string;
}) {
  return resolve(
    storeHomeNVClient.post<
      ImResponse<{
        list: Dashboard.PlatformData.CsatData[];
        total: number;
        pageNum: number;
        pageSize: number;
      }>
    >('/api_gateway/dashboard/platform/perf/csat/list', params),
  );
}

export function exportCsatList(body: {
  platform: General.PlatformUpperCase;
  departmentIds?: number[];
  storeType?: '本土' | '跨境';
  storeIds?: number[];
  scoreList?: number[];
  buyerNick: string;
  startTimeStamp: string;
  endTimeStamp: string;
  timeZone: number;
}) {
  return storeHomeNVClient.post('/api_gateway/dashboard/platform/perf/csat/export', body);
}
